import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";
import {IRRUItem} from "../../storage/interfaces/generic.interface";
import {IApiResponse} from "../../storage/interfaces/api.interface";
import {environment} from "../../../environments/environment";

const URL = environment.aws.amplify.API.REST;

@Injectable({
  providedIn: 'root'
})
export class ReferencesService {

  constructor(private _http: HttpClient) {
  }

  getRRUListByMarket(): Observable<IApiResponse<IRRUItem[]>> {
    return this._http.get<IApiResponse<IRRUItem[]>>(`${URL}references/rru/`);
  }

}
